
<template lang="pug">
aiq-tooltip(:disabled="showLabel" :content="label", :placement="placement", effect="dark", ref="tooltipRef")
  i.status-indicator(:class="statusClassName")
    span.label {{ showLabel ? label : '' }}
</template>

<script>
import get from 'lodash/get';
import capitalize from 'lodash/capitalize';
import i18n from '../mixins/i18n';

export default {
  name: 'aiqStatusIndicator',
  mixins: [i18n],
  props: {
    status: {
      type: String, // away, available, paused
      required: true,
    },
    showAllStates: {
      type: Boolean,
      required: false,
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
    placement: {
      type: String,
      default: 'bottom',
    },
  },
  mounted() {
    // Remove aria-describedby because description is already provided inline
    // and it's set by element-ui to an element we cannot control
    /* TODO: VUE3+ElementPlus
    const tooltipRef = this.$refs.tooltipRef.$el;
    tooltipRef.removeAttribute('aria-describedby');
    */
  },
  computed: {
    statusClassName() {
      if (this.status === 'paused') {
        return this.showAllStates ? 'status-at-capacity' : 'status-available';
      }
      return `status-${this.status}`;
    },
    label() {
      let label = get(this, 'status', 'away');
      if (this.showAllStates && label === 'paused') {
        label = 'busy';
      } else if (!this.showAllStates && label === 'paused') {
        label = 'available';
      }
      label = this.getString(`screen.chat.agent_status.${label}`, label);
      return capitalize(label);
    },
  },
};
</script>


<style lang="scss" scoped>
.status-indicator {
  display: inline-block;

  &::before {
    width: 10px;
    height: 10px;
    display: inline-block;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    content: ""
  }

  .label {
    padding-left: 5px;
    font-style: normal;
  }
}

.status-at-capacity {
  &::before {
    background-color: #F1B846;
    border-radius: 50%;
    }
}

.status-available {
  &::before {
    background: #00e500;
    border-radius: 50%;
    }
}

.status-away {
  &::before {
      background-image: url("data:image/svg+xml, %3Csvg width='10px' height='10px' viewBox='0 0 12 12' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3C!-- Generator: Sketch 48.1 (47250) - http://www.bohemiancoding.com/sketch --%3E %3Cdesc%3ECreated with Sketch.%3C/desc%3E %3Cdefs%3E%3C/defs%3E %3Cg id='dashboard-combine' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E %3Cg id='Message---customer-leaves-convo-Copy-3' transform='translate(-1046.000000, -119.000000)' stroke='%23BFCBD9' stroke-width='2'%3E %3Cg id='Dash-dark-blue'%3E %3Cg id='middle-right' transform='translate(332.000000, 9.000000)'%3E %3Cg id='Tooltip-big-max' transform='translate(699.000000, 57.000000)'%3E %3Cg id='tooltop-item' transform='translate(1.000000, 18.000000)'%3E %3Ccircle id='Oval-4' cx='20' cy='41' r='5'%3E%3C/circle%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E ");
    }
}

.status-paused {
  &::before {
      background-image: url("data:image/svg+xml, %3Csvg width='10px' height='10px' viewBox='0 0 10 10' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3C!-- Generator: Sketch 48.1 (47250) - http://www.bohemiancoding.com/sketch --%3E %3Cdesc%3ECreated with Sketch.%3C/desc%3E %3Cdefs%3E%3C/defs%3E %3Cg id='dashboard-combine' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E %3Cg id='Message---customer-leaves-convo-Copy-3' transform='translate(-1048.000000, -84.000000)' fill='%23BFCBD9'%3E %3Cg id='Dash-dark-blue'%3E %3Cg id='middle-right' transform='translate(332.000000, 9.000000)'%3E %3Cg id='Tooltip-big-max' transform='translate(699.000000, 57.000000)'%3E %3Cg id='tooltop-item' transform='translate(1.000000, 18.000000)'%3E %3Cg id='Group-8' transform='translate(16.000000, 0.000000)'%3E %3Crect id='Rectangle-13' x='0' y='0' width='3' height='10'%3E%3C/rect%3E %3Crect id='Rectangle-13-Copy' x='6' y='0' width='3' height='10'%3E%3C/rect%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E");
    }
}

</style>
